<template>
    <div>
      <me-action-sheet
        :value="sheetShow"
        :class="{addPadding}"
        @cancel="$emit('cancel')"
        @click-overlay="$emit('cancel')"
        :closeable="false"
        title="另存为模板"
      >
        <me-field
          ref="input"
          v-model="templateName"
          input-align="right"
          maxlength="50"
          required
          label="模板名称"
          @focus="addEventListenerForInput"
          @blur="removeEventListenerForInput"
          placeholder="请输入模板名称"/>
        <me-cell
          title="可查看范围"
          is-link
          @click.prevent="jumpSendRange"
          :value="lableINamesHasSet ? '已设置' : '未设置'"/>
        <me-cell
          title="标签"
          is-link
          @click.prevent="jumpCustomLabel"
          :value="sendRangeConfigsHasSet ? '已设置' : '未设置'"/>
        <me-button block class="close-btn" @click="$emit('cancel')">关闭</me-button>
        <me-button block class="confirm-btn" @click="confirm">确定</me-button>
      </me-action-sheet>
    </div>
  </template>
  <script>
  import { Questionnaire } from '@/network'
  import { Toast } from '@guazi-fe/melon'

  export default {
      props: {
          sheetShow: {
              type: Boolean,
              default: false,
          },
          pageId: {
            type: String,
            default: '',
          },
          pageName: {
            type: String,
            default: ''
          },
          tid: {
            type: String,
            default: '',
          }
      },
      data() {
          return {
            templateName: '',
            lableINamesHasSet: false,
            sendRangeConfigsHasSet: false,
            addPadding: false
          }
      },
      created() {
        this.templateName = this.$store.state.templateData.templateName || this.pageName + '-模版'
        if(this.$store.state.rangeList.length > 0) {
          this.lableINamesHasSet = true
        } else {
          this.lableINamesHasSet = false
        }
        if(this.$store.state.labelNames.length > 0) {
          this.sendRangeConfigsHasSet = true
        } else {
          this.sendRangeConfigsHasSet = false
        }
      },
      methods: {
        // 移动端输入时键盘弹起
        addEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            if (isAndroid) {
                this.addPadding = true
            }
        },
        removeEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            if (isAndroid) {
                this.addPadding = false
            }
        },
        jumpSendRange() {
          let data = {
            pageId: this.pageId,
            templateName: this.templateName,
            sheetShow: true
          }
          this.$store.commit('updateTemplateData', data)
          this.$router.push({
            name: 'sendingRange',
            params: {
              pageId: this.pageId
            },
            query: {
              edit: '1'
            }
          })
        },
        jumpCustomLabel() {
         let data = {
            pageId: this.pageId,
            templateName: this.templateName,
            sheetShow: true
          }
          this.$store.commit('updateTemplateData', data)
          this.$router.replace({
            name: 'customLabel',
            params: {
              pageId: this.pageId
            },
          })
        },
        create() {
            this.$router.push({
                name: 'create',
            })
        },
        createFormTemplate() {
            this.$router.push({
              name: 'template'
          })
        },
        confirm() {
          const {
            tid,
            pageId,
            templateName,
          } = this
          if (!templateName || !templateName.trim()) {
            Toast.fail('模板名称不能为空')
            return
          }
          if (templateName.length > 50) {
            Toast.fail('模板名称不能大于50字')
            return
          }
          const params = {
            tid,
            pageId,
            templateName,
            labelNames: this.$store.state.labelNames || [],
            sendRangeConfigs: this.$store.state.rangeList || [] // 模板可见范围
          }
          Questionnaire.saveTemplate(params).then(res => {
            this.$store.commit('removeRangeList')
            this.$store.commit('updateLabelNames', [])
            this.$store.commit('removeTemplateData')
            Toast.success('保存成功')
            this.$emit('cancel')
          })
        },
      },
  }
  </script>
  <style lang="scss" scoped>
  .addPadding{
      padding-bottom: 400PX!important;
  }
  .me-cell__value{
    color: #C6CBD1;
  }
  .me-icon{
    position: relative;
    top: 3px;
  }
  .me-cell::after{
    display: none;
  }
  .me-action-sheet__header {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    word-wrap: break-word;
    width: 80%;
    margin: 0 auto;
    color: #303741;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .action-sheet {
  
    border-top: 0.5px solid #F2F4F6;
    margin-bottom: 10px;
  
    > .me-col {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .action-item {
        margin: 10px;
        .icon {
          width: 24px;
          height: 24px;
        }
        .txt {
          margin-top: 10px;
          font-size: 12px;
          text-align: center;
        }
      }
    }
    .close-btn{
        border: none;
    }
  }
  .me-button--default{
    border: none;
    background: #F2F4F6;
    width: 50%;
    display: inline-block;
    margin-top: 60px;
  }
  .confirm-btn{
    background: #06B455;
    color: #fff;
  }
  
  .me-loading {
    position: absolute;
    z-index: 9000;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  </style>
  